module.exports = __webpack_public_path__ + "static/media/main idea.b66d4572.mp3";